<template>
    <component :is="tagName" ref="root" data-testid="kl-ol-map" :class="classes">
        <div class="kl-ol-map__tile-navigation">
            <slot name="tile-navigation"/>
        </div>
        <div class="kl-ol-map__body">
            <slot name="sidebar" />
            <div class="kl-ol-map__content">
                <div ref="mapRef" class="kl-ol-map__map"></div>
                <div class="kl-ol-map__search">
                    <slot name="search" />
                </div>
                <div class="kl-ol-map__action-tools">
                    <slot name="action-tools" />
                </div>
                <div class="kl-ol-map__view-tools">
                    <slot name="view-tools" />
                </div>
                <div class="kl-ol-map__info">
                    <slot name="info" />
                </div>
                <div class="kl-ol-map__base-layer">
                    <slot name="base-layer" />
                </div>
            </div>
        </div>
        <slot />
    </component>
</template>
<script lang="ts" src="./kl-ol-map.ts" />
<style lang="scss" src="./scss/_ol-map.scss" />
